var SEARCH_FIELD_BUTTON_STYLE = {
  width: '100%',
  borderRadius: {
    value: 'base'
  },
  backgroundColor: 'base.inset',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '4',
  py: '4',
  px: '8',
  minHeight: '36px'
};

export { SEARCH_FIELD_BUTTON_STYLE };
//# sourceMappingURL=constants.js.map
